module.exports = __webpack_public_path__ + "static/media/40.bba326a4.png";